import { render } from "./BasicList.vue?vue&type=template&id=0a70a570&scoped=true&ts=true"
import script from "./BasicList.vue?vue&type=script&lang=ts"
export * from "./BasicList.vue?vue&type=script&lang=ts"

import "./BasicList.vue?vue&type=style&index=0&id=0a70a570&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a70a570"]])

export default __exports__